import _ from 'lodash';
import React, { useMemo } from 'react';
import { CpWidgetVariantType } from 'api/customer-portal/types';
import { CpWidgetProps } from '../../types/widget';
import { CpFaqWidgetData } from './cp-faq-types';
import { CpFaqAccordion } from './variants/faq-accordion';
import { CpFaqGrid } from './variants/faq-grid';
import { CpFaqRow } from './variants/faq-row';

export const CpFaqWidget: React.FC<CpWidgetProps> = ({
  disabled,
  data,
  widget,
  projectId,
  onRuntimeConfigChange,
  runtimeConfig,
}) => {
  const widgetData = useMemo(() => data as CpFaqWidgetData, [data]);

  if (
    widgetData === undefined ||
    widgetData?.questionsAndAnswers === undefined
  ) {
    return <></>;
  }

  switch (widget?.widgetVariantType) {
    case CpWidgetVariantType.FAQAccordion:
    case undefined:
      return (
        <CpFaqAccordion
          disabled={disabled}
          data={widgetData}
          widget={widget}
          projectId={projectId}
          onRuntimeConfigChange={onRuntimeConfigChange}
          runtimeConfig={runtimeConfig}
        />
      );
    case CpWidgetVariantType.FAQRow:
      return (
        <CpFaqRow
          data={widgetData}
          widget={widget}
          projectId={projectId}
          onRuntimeConfigChange={onRuntimeConfigChange}
          runtimeConfig={runtimeConfig}
          disabled={disabled}
        />
      );
    case CpWidgetVariantType.FAQGrid:
      return (
        <CpFaqGrid
          data={widgetData}
          widget={widget}
          projectId={projectId}
          onRuntimeConfigChange={onRuntimeConfigChange}
          runtimeConfig={runtimeConfig}
          disabled={disabled}
        />
      );
    default:
      return <></>;
  }
};
